// extracted by css-extract-rspack-plugin
export default {"collector":"collector-NmHmkw","hidden":"hidden-JglAS_"};